import req from "../../http";

const contactRecord = {
  // 取得 履歷聯繫紀錄
  getContactRecord(ResumeId) {
    return req("get", `/ResumeModule/ContactRecord/${ResumeId}`);
  },

  // 新增 履歷聯繫紀錄
  postContactRecord(params) {
    return req("post", "/ResumeModule/ContactRecord/Add", params);
  },

  // 取得 履歷聯繫狀態選項(邀約狀態)
  getContactStatus(params) {
    return req("get", "/ResumeModule/ContactRecord/Statuses", params);
  },

  // 取得 複合查詢 聯繫狀態選項
  getContactStatusForQuery(params) {
    return req("get", "/ResumeModule/ContactRecord/Statuses?forSearch=true", params);
  },

  // 刪除 履歷聯繫紀錄
  deleteContactRecord(Id) {
    return req("delete", `/ResumeModule/ContactRecord/Delete/?Id=${Id}`, );
  }
};

export default contactRecord;